import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { WaitlistProvider } from './context/WaitlistContext';
import WaitlistPopup from './components/WaitlistPopup/WaitlistPopup';
import { useWaitlist } from './context/WaitlistContext';
import DocumentHead from './components/DocumentHead/DocumentHead';
import './App.css';
import Home from './pages/Home';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import AppPrivacy from './pages/AppPrivacy';
import Troubleshooting from './pages/Troubleshooting';
import Share from './pages/Share';
import VendorOffer from './pages/VendorOffer';
import VendorOfferSuccess from './pages/VendorOfferSuccess';
import NotFound from './pages/NotFound';

const AppContent: React.FC = () => {
  const { isOpen, closePopup } = useWaitlist();

  return (
    <Router>
      <WaitlistPopup isOpen={isOpen} onClose={closePopup} />
      <DocumentHead />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/share" element={<Share />} />
        <Route path="/vendor-offer/:partner/success" element={<VendorOfferSuccess />} />
        <Route path="/vendor-offer/:token" element={<VendorOffer />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/app-privacy" element={<AppPrivacy />} />
        <Route path="/troubleshooting" element={<Troubleshooting />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
};

const App: React.FC = () => {
  return (
    <WaitlistProvider>
      <AppContent />
    </WaitlistProvider>
  );
};

export default App; 